import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onemonthrentalcorporatecabservice() {



  const cardData =
  {
    keyword: 'One Month Rental Corporate Cab Services in Chennai',
    heading: 'Aaryan Travels: One Month Rental Corporate Cab Services in Chennai',
    headingDescription: 'Aaryan Travels offers One Month Rental Corporate Cab Services in Chennai for businesses, executives, and employees who require dedicated transportation for short-term corporate commitments. Whether it is for project-based travel, visiting teams, or temporary staff movement, our chauffeur-driven sedans, SUVs, and tempo travellers are available on flexible one-month rental contracts. With professional drivers, punctual reporting, GPS-enabled vehicles, and transparent billing, we ensure smooth mobility across key corporate zones like OMR, Guindy, Ambattur, and Siruseri. Aaryan Travels makes corporate travel in Chennai effortless with well-managed monthly cab rental solutions tailored to your operational needs.',

    top: 'Top Places to Visit in Chennai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is India’s longest urban beach, stretching over 13 kilometers along the Bay of Bengal. Visitors flock here for sunrise views, horse rides, and local snacks like sundal and murukku. The beachside promenade features statues, memorials, and walking paths. Evenings are filled with lively crowds and refreshing sea breeze. Marina Beach is Chennai’s iconic coastal retreat."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Located in Mylapore, Kapaleeshwarar Temple is a stunning Dravidian-style shrine dedicated to Lord Shiva. The temple’s towering gopuram is adorned with colorful sculptures depicting mythological stories. Pilgrims participate in rituals and festivals like Panguni Peruvizha with devotion. The surroundings are filled with traditional flower and craft shops. Kapaleeshwarar Temple is Chennai’s spiritual masterpiece."
  },
  {
    "title": "Fort St. George",
    "description": "Built in 1644 by the British East India Company, Fort St. George is the first English fortress in India. It now houses the Tamil Nadu Legislative Assembly and a museum displaying colonial artifacts, coins, and weaponry. The fort’s historic architecture reflects colonial power and heritage. Fort St. George is Chennai’s landmark of political and historical significance."
  },
  {
    "title": "Santhome Basilica",
    "description": "Santhome Basilica is a beautiful white Gothic-style church built over the tomb of Saint Thomas the Apostle. The stained-glass windows and peaceful interiors create a serene atmosphere. The underground chapel holds sacred relics of the saint. Located near the beach, it offers a picturesque view. Santhome Basilica is Chennai’s sacred symbol of Christian heritage."
  },
  {
    "title": "Elliot’s Beach (Besant Nagar Beach)",
    "description": "Elliot’s Beach is a cleaner and quieter alternative to Marina Beach, popular among youngsters and families. Visitors enjoy evening strolls, seaside cafes, and calm waves. The Karl Schmidt Memorial and nearby Ashtalakshmi Temple add charm to the shoreline. Elliot’s Beach is Chennai’s relaxed seaside escape."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a grand monument dedicated to the celebrated Tamil poet Thiruvalluvar. Built in the shape of a temple chariot, it features inscriptions of all 1,330 couplets from the Thirukkural. The surrounding auditorium hosts cultural events and exhibitions. Valluvar Kottam is Chennai’s architectural tribute to literature and wisdom."
  },
  {
    "title": "Government Museum, Egmore",
    "description": "The Government Museum in Egmore is one of India’s oldest museums, showcasing artifacts from archaeology, zoology, numismatics, and art. The National Art Gallery inside features stunning paintings and bronze idols. The Indo-Saracenic architecture adds grandeur. It offers educational engagement for all age groups. The museum is Chennai’s cultural encyclopedia."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park is one of the smallest yet richest urban forests in India. It is home to blackbucks, spotted deer, jackals, and over 100 species of birds. The adjoining Children’s Park and Snake Park make it a popular family destination. Shaded pathways offer nature lovers a peaceful escape. Guindy Park is Chennai’s refreshing green lung."
  },
  {
    "title": "Express Avenue Mall",
    "description": "Express Avenue Mall is a popular shopping and entertainment complex featuring international brands, multiplex cinemas, and a large food court. South India’s biggest gaming arcade attracts youngsters. The modern interiors and lively ambiance make it a favorite hangout spot. Express Avenue is Chennai’s lifestyle destination."
  },
  {
    "title": "Arignar Anna Zoological Park (Vandalur Zoo)",
    "description": "Vandalur Zoo is India’s largest zoological park, spread across 1,500 acres. It houses lions, tigers, elephants, reptiles, and rare bird species. Safari rides, butterfly parks, and well-maintained trails offer adventure and learning. It is ideal for family outings and school trips. Vandalur Zoo is Chennai’s wild world of nature."
  }
],


"services": [
  {
    "name": "One Month Rental Corporate Cab Services in Chennai",
    "description": "One Month Rental Corporate Cab Services in Chennai offers reliable and flexible transportation plans for companies. Designed for long-term use, this service ensures professional drivers, clean vehicles, and on-time daily commutes for your employees and executives."
  },
  {
    "name": "Chennai Monthly Corporate Cab",
    "description": "Chennai Monthly Corporate Cab service is tailored for businesses needing consistent transport solutions. With fixed monthly pricing, dedicated vehicles, and trained chauffeurs, we ensure a hassle-free and cost-efficient corporate travel experience."
  },
  {
    "name": "Corporate Cab Hire Chennai Monthly",
    "description": "Corporate Cab Hire Chennai Monthly provides scalable cab services with flexible rental durations. Whether you need transport for employees, executives, or clients, our monthly hire plans ensure reliability, punctuality, and comfort."
  },
  {
    "name": "Business Cab Chennai",
    "description": "Business Cab Chennai offers seamless and professional cab services for corporate travel. Our fleet of well-maintained vehicles and courteous chauffeurs supports meetings, airport transfers, and city travel for businesses of all sizes."
  },
  {
    "name": "Staff Transportation Chennai",
    "description": "Staff Transportation Chennai ensures safe and timely daily commutes for your workforce. Our service includes route planning, tracking, and scheduled pickups, offering peace of mind and efficiency for your HR and operations teams."
  },
  {
    "name": "Chauffeur Corporate Cab Chennai",
    "description": "Chauffeur Corporate Cab Chennai features experienced, well-groomed chauffeurs trained in corporate service standards. Perfect for executives and business clients, our service offers discretion, comfort, and punctuality across every trip."
  },
  {
    "name": "Corporate Taxi Chennai Monthly",
    "description": "Corporate Taxi Chennai Monthly is designed for businesses that require dependable taxi services for recurring travel. With dedicated support, clean cars, and monthly invoicing, we help streamline corporate transportation effortlessly."
  },
  {
    "name": "Executive Corporate Cab Chennai",
    "description": "Executive Corporate Cab Chennai provides luxury transport solutions for top-level executives. Our high-end vehicles, professional drivers, and customer-focused approach ensure a premium travel experience for business leaders and VIP clients."
  },
  {
    "name": "Affordable Monthly Corporate Cab Chennai",
    "description": "Affordable Monthly Corporate Cab Chennai offers cost-effective transport solutions for companies without compromising on quality. Get clean, GPS-enabled vehicles and polite drivers under a transparent monthly plan tailored to your needs."
  },
  {
    "name": "Corporate Vehicle Rental Chennai",
    "description": "Corporate Vehicle Rental Chennai provides a wide range of vehicles for long-term rental including sedans, SUVs, and premium cars. Ideal for staff movement or event logistics, our rentals come with flexible terms and maintenance support."
  },
  {
    "name": "Monthly Office Cab Chennai",
    "description": "Monthly Office Cab Chennai is a dedicated service for daily employee commutes. Fixed schedules, real-time tracking, and a professional fleet make this service perfect for companies looking to enhance employee transport efficiency."
  },
  {
    "name": "Online Corporate Cab Chennai",
    "description": "Online Corporate Cab Chennai allows easy booking, ride management, and billing via a digital dashboard. Streamline your corporate transport logistics with real-time tracking, centralized reporting, and seamless monthly plan management."
  },
  {
    "name": "Corporate Travel Services Chennai",
    "description": "Corporate Travel Services Chennai offers complete transportation support for businesses including airport transfers, intercity travel, and local commutes. Our professional team ensures on-time service and consistent ride quality across every booking."
  },
  {
    "name": "Chennai Business Cab Monthly",
    "description": "Chennai Business Cab Monthly delivers customized cab services for business houses and professionals. Enjoy priority support, clean vehicles, and corporate billing — all under a reliable monthly plan suited to your organization's travel needs."
  },
  {
    "name": "Premium Corporate Cab Chennai",
    "description": "Premium Corporate Cab Chennai provides luxury cars with top-tier service standards for corporate clients. Ideal for executive travel and VIP events, our fleet includes high-end sedans and SUVs with chauffeurs trained in business etiquette."
  }
],
"tableData": [
  ["One Month Rental Corporate Cab Services in Chennai", "Chennai Monthly Corporate Cab"],
  ["Corporate Cab Hire Chennai Monthly", "Business Cab Chennai"],
  ["Staff Transportation Chennai", "Chauffeur Corporate Cab Chennai"],
  ["Corporate Taxi Chennai Monthly", "Executive Corporate Cab Chennai"],
  ["Affordable Monthly Corporate Cab Chennai", "Corporate Vehicle Rental Chennai"],
  ["Monthly Office Cab Chennai", "Online Corporate Cab Chennai"],
  ["Corporate Travel Services Chennai", "Chennai Business Cab Monthly"],
  ["Premium Corporate Cab Chennai", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "One Month Rental Corporate Cab Services in Chennai",
    "WhyChoosedescription": "Aaryan Travels provides reliable one-month rental corporate cab services in Chennai for hassle-free business travel."
  },
  {
    "WhyChooseheading": "Timely and Professional Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs ensure punctual pickups and drop-offs, keeping your corporate schedule on track."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, sanitized cars maintained for your safety and comfort throughout the month."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Chennai Routes",
    "WhyChoosedescription": "Our drivers have in-depth knowledge of Chennai’s roads for efficient and smooth rides."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances for worry-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Assistance",
    "WhyChoosedescription": "Our support team is available round the clock to assist you with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans Tailored to Your Needs",
    "WhyChoosedescription": "Choose from various plans designed to suit your corporate travel requirements."
  },
  {
    "WhyChooseheading": "Wide Selection of Vehicle Options",
    "WhyChoosedescription": "Select from sedans, SUVs, and other vehicles to match your business travel preferences."
  }
]






































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer one month rental corporate cab services in Chennai?',
    answer: 'Yes, Aaryan Travels provides flexible and affordable one month rental corporate cab services in Chennai tailored to business needs.',
  },
  {
    question: 'How can I book one month rental corporate cab services in Chennai with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our dedicated 24x7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for one month rental corporate cab services in Chennai?',
    answer: 'Aaryan Travels offers a variety of vehicles including sedans, SUVs, and premium cars suitable for corporate travel.',
  },
  {
    question: 'Are drivers experienced with Chennai city routes for one month rental corporate cabs?',
    answer: 'Absolutely. Our professional drivers are licensed and well-versed with Chennai routes to ensure timely and comfortable rides.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for one month rental corporate cab services in Chennai?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points anywhere in Chennai and nearby business areas.',
  },
  {
    question: 'Is the one month rental corporate cab service available 24x7 in Chennai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock service for one month rental corporate cab plans to fit your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for one month rental corporate cab services?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols for your protection.',
  },
  {
    question: 'What payment options are accepted for one month rental corporate cab services in Chennai?',
    answer: 'We accept cash, corporate accounts, digital wallets, UPI, and card payments for your convenience.',
  },
  {
    question: 'Is customer support available during one month rental corporate cab services in Chennai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Iyer',
    feedback: 'Aaryan Travels’ one month rental corporate cab service in Chennai made our employee commute smooth and efficient.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavya Ramesh',
    feedback: 'Professional and reliable one month rental corporate cab service by Aaryan Travels in Chennai. Highly recommended!',
    rating: 5,
  },
];























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];






const oneMonthCorporateCabChennaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "One Month Rental Corporate Cab Services in Chennai",
  "description": "Aaryan Travels offers one month rental corporate cab services in Chennai, providing affordable, chauffeur-driven executive and staff transportation solutions for businesses.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Chennai"
  },
  "serviceType": "Monthly Corporate Cab Rental",
  "keywords": "One Month Rental Corporate Cab Services in Chennai, Chennai Monthly Corporate Cab, Corporate Cab Hire Chennai Monthly, Business Cab Chennai, Staff Transportation Chennai, Chauffeur Corporate Cab Chennai, Corporate Taxi Chennai Monthly, Executive Corporate Cab Chennai, Affordable Monthly Corporate Cab Chennai, Corporate Vehicle Rental Chennai, Monthly Office Cab Chennai, Online Corporate Cab Chennai, Corporate Travel Services Chennai, Chennai Business Cab Monthly, Premium Corporate Cab Chennai"
};









  return (
    <div>
<Helmet>
  <title>One Month Rental Corporate Cab Services in Chennai | Affordable Monthly Corporate Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Book one month rental corporate cab services in Chennai with Aaryan Travels. Affordable chauffeur-driven executive and staff cabs for your business needs."
  />
  <meta
    name="keywords"
    content="One Month Rental Corporate Cab Services in Chennai, Chennai Monthly Corporate Cab, Corporate Cab Hire Chennai Monthly, Business Cab Chennai, Staff Transportation Chennai, Chauffeur Corporate Cab Chennai, Corporate Taxi Chennai Monthly, Executive Corporate Cab Chennai, Affordable Monthly Corporate Cab Chennai, Corporate Vehicle Rental Chennai, Monthly Office Cab Chennai, Online Corporate Cab Chennai, Corporate Travel Services Chennai, Chennai Business Cab Monthly, Premium Corporate Cab Chennai"
  />
  <script type="application/ld+json">
    {JSON.stringify(oneMonthCorporateCabChennaiSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/56.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onemonthrentalcorporatecabservice;